module.exports = __webpack_public_path__ + "static/media/Check.8706fb53.svg";